<template>
  <div class="bg-white min-h-screen">
    <!-- START HERO CONTENT -->
    <div class="hero-content">
      <TopNav />
      <div class="pt-20" style="height: 750px">
        <p
          class="
            text-brand-blue text-center
            capitalize
            font-semibold
            pb-5
            content-header
          "
        >
          Fast, Easy & Free
        </p>
        <h1
          class="text-center capitalize pt-3 md:py-3 font-semibold hero-header"
        >
          {{ $route.meta.main ? $route.meta.main : "Streamlined" }}
        </h1>
        <h1 class="text-brand-blue text-center capitalize py-3 hero-header">
          <span class="highlight text-brand-blue">{{
            $route.meta.highlight
              ? $route.meta.highlight
              : $route.meta.main
              ? ""
              : "Tenant Screening"
          }}</span>
        </h1>
        <h2 class="text-brand-black text-center text-base py-5">
          {{
            $route.meta.sub ||
            "Reduce risk and find high quality tenants with Rent Application’s optimized process."
          }}
        </h2>
        <div class="w-full">
          <router-link
            tag="div"
            class="block px-2 md:px-0 py-2 w-full md:w-52 my-5 mx-auto"
            :to="{ name: 'home_signup' }"
            ><PrimaryButton>Start screening today</PrimaryButton></router-link
          >
        </div>
        <p class="italic text-base text-center text-brand-gray mb-10">
          Sign up and be ready to receive credit, eviction, and criminal reports
          in minutes.
        </p>
        <div
          class="w-11/12 md:w-1/2 md:max-w-xl mx-auto rounded relative"
          style="
            background: linear-gradient(180deg, #ffffff 0%, #ececec 100%);
            box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
          "
        >
          <img
            class="w-full rounded"
            src="@/assets/images/application.png"
            alt="credit report"
          />
        </div>
      </div>
      <div style="height: 100px"></div>
    </div>

    <!-- START TRUST BY CONTENT -->
    <div class="px-3 py-8 md:py-20 md:px-8 gray-background">
      <h5
        class="
          mb-5
          md:mt-24 md:mb-10
          section-header
          text-brand-blue
          uppercase
          text-center
        "
      >
        Trusted by
      </h5>

      <div class="hidden md:block mx-auto" style="max-width: 1000px">
        <div class="my-16 flex flex-row justify-between">
          <img src="@/assets/images/remax.png" />
          <img src="@/assets/images/atproperties.png" />
          <img src="@/assets/images/related.png" />
          <img src="@/assets/images/realtor.png" />
        </div>
        <div class="my-8 flex flex-row justify-between">
          <img src="@/assets/images/keller.png" />
          <img src="@/assets/images/coldwell.png" />
          <img src="@/assets/images/berkshire.png" />
          <img class="max-h-16" src="@/assets/images/c21.png" />
          <img class="max-h-16" src="@/assets/images/sothebys.png" />
        </div>
      </div>

      <div class="block md:hidden mx-auto">
        <div class="py-3 flex flex-row justify-evenly">
          <img class="max-w-2/5" src="@/assets/images/remax.png" />
          <img class="max-w-2/5" src="@/assets/images/atproperties.png" />
        </div>
        <div class="py-3 flex flex-row justify-evenly">
          <img class="max-w-2/5" src="@/assets/images/related.png" />
          <img class="max-w-2/5" src="@/assets/images/realtor.png" />
        </div>
        <div class="py-3 flex flex-row justify-evenly">
          <img class="max-w-2/5" src="@/assets/images/keller.png" />
          <img class="max-w-2/5" src="@/assets/images/coldwell.png" />
        </div>
        <div class="py-3 flex flex-row justify-evenly">
          <img class="max-w-2/5" src="@/assets/images/berkshire.png" />
          <img class="max-w-2/5 max-h-16" src="@/assets/images/c21.png" />
        </div>
        <div class="py-3 flex flex-row justify-evenly">
          <img class="max-w-2/5 max-h-16" src="@/assets/images/sothebys.png" />
        </div>
      </div>
    </div>
    <!-- END TRUST BY CONTENT -->

    <!-- START FIND BETTER TENANT CONTENT -->
    <div
      class="
        better-tenants-container
        md:max-w-screen-lg
        mx-auto
        bg-white
        px-3
        py-10
        md:py-24 md:pl-24 md:pr-5
      "
    >
      <div class="">
        <div class="py-5 md:py-2">
          <h2 class="text-5xl md:text-6xl py-1">Find better tenants in</h2>
          <h2 class="text-5xl md:text-6xl py-1 text-brand-blue">
            under 1 minute
          </h2>
        </div>
        <div class="flex flex-col-reverse md:flex-row md:py-5">
          <div class="md:w-2/5 md:pr-20">
            <div class="flex py-3 pt-5 md:py-2">
              <img class="mr-3" src="@/assets/images/clock.svg" width="19" />
              <div class="flex items-center ml-1">
                <span class="italic text-brand-gray text-sm md:text-base"
                  >32.5 seconds</span
                >
              </div>
            </div>

            <div class="pt-2 md:pb-5 flex flex-row">
              <div
                class="w-1/2 h-1 bg-brand-background-blue-gray mr-2 first-half"
              >
                <div class="w-0 h-full bg-brand-green" ref="firstBar"></div>
              </div>
              <div class="w-1/2 h-1 bg-brand-background-blue-gray second-half">
                <div class="w-0 h-full bg-brand-green" ref="secondBar"></div>
              </div>
            </div>
            <p class="text-2xl py-2">Select the reports to receive</p>
            <p>
              Name your application, optionally customize the url, and that’s
              it; you’re set to start receiving applicant reports in just
              seconds.
            </p>
            <p class="text-2xl pt-5 pb-2">Easily share the application</p>
            <p>
              No more sending PDFs.
              <br />
              Email prospective renters a link to your application form in just
              one click from your dashboard.
              <br />
            </p>
            <div class="py-8">
              <router-link
                tag="a"
                :to="{ name: 'home_signup' }"
                class="text-brand-green text-xl"
                >Start receiving reports ></router-link
              >
            </div>
          </div>
          <div class="flex items-center w-full md:w-3/5">
            <div class="w-full">
              <div class="w-full" id="better" ref="better"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="py-16">
        <div class="flex flex-col md:flex-row">
          <div class="md:w-1/2">
            <img src="@/assets/images/anytime.png" class="md:w-10/12" />
          </div>
          <div class="md:w-1/2">
            <h2 class="text-5xl md:text-6xl py-2 md:pt-28">Anytime,</h2>
            <h2 class="text-5xl md:text-6xl py-2">anywhere,</h2>
            <h2 class="text-5xl md:text-6xl text-brand-blue py-2">
              any device
            </h2>
            <br />
            <p class="md:max-w-2/3">
              Using our EasyApply technology, applicants can easily submit their
              information on any device using your unique form link.
            </p>
            <br />
            <router-link
              tag="a"
              :to="{ name: 'home_signup' }"
              class="text-brand-green text-xl"
              >Find better tenants ></router-link
            >
          </div>
        </div>
      </div>
    </div>
    <!-- END FIND BETTER TENANT CONTENT -->

    <!-- START ELIMINATE DELAY CONTENT -->
    <div class="px-3 pt-8 gray-background">
      <div class="mx-auto md:max-w-2/3">
        <h2 class="text-5xl md:text-6xl text-brand-blue text-center py-2">
          Eliminate delay
        </h2>
        <h2 class="text-5xl md:text-6xl text-center py-2">
          View reports immediately
        </h2>

        <p class="py-8 md:max-w-4/5 text-center mx-auto">
          Our full Credit, Criminal, and Eviction reports are processed
          immediately once an applicant applies so you can evaluate applicants
          in minutes.
        </p>
        <div class="py-5">
          <router-link
            tag="a"
            class="block py-2 w-full md:w-52 mx-auto text-center"
            :to="{ name: 'home_signup' }"
            ><PrimaryButton>Get Started</PrimaryButton></router-link
          >
        </div>

        <img class="pt-5 mx-auto" src="@/assets/images/reports.png" />
      </div>
    </div>
    <!-- END ELIMINATE DELAY CONTENT -->

    <!-- START IMPROVE YOUR BUSINESS CONTENT -->
    <div
      class="md:max-w-screen-lg mx-auto bg-white px-3 py-10 md:py-10 md:pr-5"
    >
      <div class="">
        <div class="py-5 md:py-2">
          <h2 class="text-5xl md:text-6xl py-1">Improve your business</h2>
          <h2 class="text-5xl md:text-6xl py-1 text-brand-blue">
            no matter the size
          </h2>
        </div>
        <div class="flex flex-col-reverse md:flex-row md:py-5">
          <div class="px-3 w-full md:w-2/5 md:pr-20">
            <div class="py-3">
              <img src="@/assets/images/agent-group-1.png" class="md:hidden" />
              <h5 class="text-xl py-2">Real estate agents</h5>
              <p class="text-sm">
                We help small teams and offices save time with a streamlined
                process to create, send, and review applications any day of the
                week. Easily send applications to clients with 1-click.
              </p>
            </div>
            <div class="py-3">
              <img src="@/assets/images/agent-group-2.png" class="md:hidden" />
              <h5 class="text-xl py-2">Property managers</h5>
              <p class="text-sm">
                Use ActiveLink™ to customize applications and URLs, then track
                the application with our Audit History. Minimize risk: accept or
                decline applicants and generate FCRA compliant adverse action
                letters with one click.
              </p>
            </div>
            <div class="py-3">
              <img src="@/assets/images/agent-group-3.png" class="md:hidden" />
              <h5 class="text-xl py-2">Landlords</h5>
              <p class="text-sm">
                Save money and empower your screening process with the same
                tools used by the largest professional brokerages for free.
              </p>
            </div>
            <div class="py-3">
              <h5 class="text-xl py-2">Your applicants</h5>
              <p class="text-sm">
                Stand out from the competition with worry-free identity
                protection for applicants that shields their SSN.
              </p>
            </div>
          </div>
          <div class="hidden md:block pt-5 px-1 md:w-3/5">
            <img src="@/assets/images/agents-grouped.png" />
          </div>
        </div>
      </div>
    </div>
    <!-- END IMPROVE YOUR BUSINESS CONTENT -->

    <!-- START ACCURATE REPORTS CONTENT -->
    <div class="px-3 py-8 md:pl-24 bg-white">
      <div class="flex md:flex-row my-8">
        <div class="hidden md:block md:w-2/5">
          <div
            class="overflow-y-scroll py-2 px-2 shadow rounded"
            style="max-height: 36rem"
          >
            <img
              src="@/assets/images/experian-credit.png"
              class="w-full"
              v-if="currentReport === 'credit'"
            />
            <img
              src="@/assets/images/criminal.png"
              class="w-full"
              v-if="currentReport === 'criminal'"
            />
            <img
              src="@/assets/images/eviction.png"
              class="w-full"
              v-if="currentReport === 'eviction'"
            />
          </div>
        </div>
        <div class="md:w-3/5 md:pl-20">
          <h2 class="text-5xl md:text-6xl text-brand-blue py-2">Accurate</h2>
          <h2 class="text-5xl md:text-6xl py-2">& reliable reports</h2>
          <br />
          <p class="md:w-2/3">
            We offer full credit reports that include the credit score, detailed
            tradeline information, debt summary table, and more.
          </p>
          <div class="flex flex-row py-5">
            <img src="@/assets/images/fico.png" class="h-5 md:h-8 pr-4" />
            <img src="@/assets/images/vantage.png" class="h-5 md:h-8 pr-4" />
            <img src="@/assets/images/experian-logo.png" class="h-5 md:h-8" />
          </div>

          <div
            class="
              md:hidden
              max-h-60
              overflow-y-scroll
              py-2
              px-2
              shadow
              rounded
            "
          >
            <img
              src="@/assets/images/experian-credit.png"
              class="w-full"
              v-if="currentReport === 'credit'"
            />
            <img
              src="@/assets/images/criminal.png"
              class="w-full"
              v-if="currentReport === 'criminal'"
            />
            <img
              src="@/assets/images/eviction.png"
              class="w-full"
              v-if="currentReport === 'eviction'"
            />
          </div>

          <div class="py-3">
            <div
              class="block rounded-sm py-2 w-full md:w-1/2 text-center"
              href="#"
              @click="toggleReport('credit')"
              :class="[
                currentReport === 'credit'
                  ? 'bg-brand-green text-white'
                  : 'border-2 border-brand-dark-gray bg-white text-brand-black cursor-pointer'
              ]"
            >
              Credit report
            </div>
          </div>
          <div class="py-3">
            <div
              class="block rounded-sm py-2 w-full md:w-1/2 text-center"
              href="#"
              @click="toggleReport('criminal')"
              :class="[
                currentReport === 'criminal'
                  ? 'bg-brand-green text-white'
                  : 'border-2 border-brand-dark-gray bg-white text-brand-black cursor-pointer'
              ]"
            >
              Criminal report
            </div>
          </div>
          <div class="py-3">
            <div
              class="block rounded-sm py-2 w-full md:w-1/2 text-center"
              href="#"
              @click="toggleReport('eviction')"
              :class="[
                currentReport === 'eviction'
                  ? 'bg-brand-green text-white'
                  : 'border-2 border-brand-dark-gray bg-white text-brand-black cursor-pointer'
              ]"
            >
              Eviction report
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END ACCURATE REPORTS CONTENT -->

    <!-- START FEATURES CONTENT -->
    <div class="px-3 py-8 md:pl-24 gray-background">
      <div class="flex flex-col my-8">
        <div class="py-3 md:w-1/2 mx-auto">
          <h2 class="text-5xl md:text-6xl py-2 text-center">
            No subscriptions
          </h2>
          <h2 class="text-5xl md:text-6xl py-2 text-center">
            & no surprise fees
          </h2>
        </div>
        <div class="py-3 md:w-3/5 mx-auto">
          <p class="">
            Rent Application is FREE for Agents, Landlords, and Managers. You
            select the reports you want, and your applicants pay the
            <!-- TODO: Add report fee modal -->
            <span class="text-brand-green cursor-pointer">report fees.</span>
          </p>
        </div>

        <div class="py-3 w-full md:w-3/5 mx-auto">
          <h5 class="text-xl py-5 text-center font-semibold">
            All features included
          </h5>
          <div class="hidden md:flex flex-row justify-between pt-5">
            <div class="flex flex-col w-22">
              <img src="@/assets/images/unlimited.svg" />
              <p class="py-3">Unlimited forms</p>
            </div>

            <div class="flex flex-col w-20">
              <img src="@/assets/images/credit.svg" />
              <p class="py-3">Credit reports</p>
            </div>

            <div class="flex flex-col w-20">
              <img src="@/assets/images/criminal.svg" />
              <p class="py-3">Criminal records</p>
            </div>

            <div class="flex flex-col w-20">
              <img src="@/assets/images/eviction.svg" />
              <p class="py-3">Eviction history</p>
            </div>

            <div class="flex flex-col w-20">
              <img src="@/assets/images/app.svg" />
              <p class="py-3">Customizable applications</p>
            </div>
          </div>

          <div class="flex md:hidden flex-col pt-5 px-5">
            <div class="flex flex-row justify-between pb-5">
              <div class="flex flex-col w-16">
                <img src="@/assets/images/unlimited.svg" />
                <p class="py-3">Unlimited forms</p>
              </div>

              <div class="flex flex-col w-16">
                <img src="@/assets/images/credit.svg" />
                <p class="py-3">Credit reports</p>
              </div>

              <div class="flex flex-col w-16">
                <img src="@/assets/images/criminal.svg" />
                <p class="py-3">Criminal records</p>
              </div>
            </div>

            <div class="flex flex-row justify-evenly">
              <div class="flex flex-col w-16">
                <img src="@/assets/images/eviction.svg" />
                <p class="py-3">Eviction history</p>
              </div>

              <div class="flex flex-col w-16">
                <img src="@/assets/images/app.svg" />
                <p class="py-3">Customizable applications</p>
              </div>
            </div>
          </div>

          <div class="py-5 mx-auto">
            <router-link
              tag="a"
              :to="{ name: 'home_signup' }"
              class="block py-2 w-full md:w-1/2 text-center mx-auto"
              ><PrimaryButton>Get Started</PrimaryButton></router-link
            >
          </div>
        </div>
      </div>
    </div>
    <!-- END FEATURES CONTENT -->

    <!-- START GROW YOUR BUSINESS CONTENT -->
    <div
      class="
        better-tenants-container
        mx-auto
        bg-white
        px-3
        py-10
        md:py-24 md:pl-24 md:pr-10
      "
    >
      <div class="">
        <div class="py-5 md:py-2"></div>
        <div class="flex flex-col md:flex-row md:py-5">
          <div class="md:w-3/5 md:pr-20">
            <h2 class="text-5xl md:text-6xl py-2">Learn how</h2>
            <div class="flex flex-row">
              <img
                class="hidden md:block w-10 mr-3"
                src="@/assets/images/main-logo.svg"
              />
              <h2 class="text-5xl md:text-6xl py-2 text-brand-blue">
                Rent Application
              </h2>
            </div>
            <h2 class="text-5xl md:text-6xl py-2">Can grow your business</h2>
            <p class="pt-5">
              Brokerages of all sizes use Rent Application Brokerage. Learn how
              Rent Application Brokerage can help you grow your business.
            </p>
            <div class="py-8">
              <router-link
                tag="a"
                :to="{ name: 'home_signup' }"
                class="block rounded-sm py-2 w-full md:w-1/2 text-center"
                ><PrimaryButton>Learn More</PrimaryButton></router-link
              >
            </div>
          </div>
          <div class="md:w-2/5">
            <img class="hidden md:block" src="@/assets/images/customized.png" />
            <img
              class="md:hidden"
              src="@/assets/images/customized-mobile.png"
            />
            <p class="md:hidden py-5 text-center">
              Customized Applications & Emails
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- END GROW YOUR BUSINESS CONTENT -->

    <!-- START TESTIMONIAL CONTAINER -->
    <div class="px-3 py-16 testimonial-background">
      <div class="mx-auto md:max-w-screen-md">
        <h2 class="text-3xl text-center pb-5 md:pb-10">
          See what our fans have to say
        </h2>

        <div
          class="testimonial-container relative z-30"
          ref="testimonialContainer"
        >
          <img
            src="@/assets/images/start_quote.svg"
            class="
              absolute
              -left-3
              -top-6
              md:-left-10 md:-top-10
              w-10
              h-10
              md:w-16 md:h-16
              z-0
            "
          />
          <div
            class="full-width overflow-hidden flex justify-between px-5 md:px-0"
          >
            <transition name="slide">
              <div
                class="
                  bg-white
                  py-5
                  px-5
                  md:py-10 md:px-10
                  rounded
                  shadow-lg
                  z-30
                  h-56
                  relative
                  md:max-w-screen-md
                  mx-auto
                "
                :key="currentTestimonialIndex"
              >
                <p class="py-1">
                  {{ testimonials[currentTestimonialIndex].content }}
                </p>
                <p class="pt-5 text-brand-blue font-semibold">
                  {{ testimonials[currentTestimonialIndex].name }}
                </p>
                <p class="py-1 text-sm">
                  {{ testimonials[currentTestimonialIndex].userType }}
                </p>
              </div>
            </transition>
          </div>

          <img
            src="@/assets/images/end_quote.svg"
            class="
              absolute
              -right-2
              -bottom-6
              md:-bottom-10 md:-right-10
              w-10
              h-10
              md:w-16 md:h-16
              z-0
            "
          />
        </div>

        <div class="flex flex-row justify-center py-5">
          <div
            class="rounded-xl w-3 h-3 md:w-5 md:h-5 mx-1 cursor-pointer"
            :class="[
              currentTestimonialIndex === 0
                ? 'bg-brand-green'
                : 'bg-brand-mid-gray'
            ]"
            @click="setTestimonialIndex(0)"
          ></div>
          <div
            class="rounded-xl w-3 h-3 md:w-5 md:h-5 mx-1 cursor-pointer"
            :class="[
              currentTestimonialIndex === 1
                ? 'bg-brand-green'
                : 'bg-brand-mid-gray'
            ]"
            @click="setTestimonialIndex(1)"
          ></div>
          <div
            class="rounded-xl w-3 h-3 md:w-5 md:h-5 mx-1 cursor-pointer"
            :class="[
              currentTestimonialIndex === 2
                ? 'bg-brand-green'
                : 'bg-brand-mid-gray'
            ]"
            @click="setTestimonialIndex(2)"
          ></div>
        </div>
      </div>
    </div>
    <!-- END TESTIMONIAL CONTAINER -->

    <!-- START PROSPECTIVE TENANT CONTAINER -->
    <div class="px-3 py-16 prospective-background">
      <div class="mx-auto md:max-w-2/3">
        <h2 class="text-5xl md:text-6xl text-white text-center py-2 font-light">
          Prospective Tenants can start
        </h2>
        <h2 class="text-5xl md:text-6xl text-white text-center py-2 font-light">
          applying in minutes
        </h2>
        <p class="py-8 text-white text-center font-light">
          Start screening tenants fast with comprehensive and accurate reports
          for FREE
        </p>

        <div class="pb-8">
          <router-link
            tag="a"
            class="block py-2 w-full md:w-1/3 mx-auto text-center"
            :to="{ name: 'home_signup' }"
            ><PrimaryButton>Start screening today</PrimaryButton></router-link
          >
        </div>
      </div>
    </div>
    <!-- END PROSPECTIVE TENANT CONTAINER -->
  </div>
  <Footer />
</template>
<script>
import lottie from "lottie-web"
import better from "@/assets/animations/better.json"

export default {
  created() {
    window.addEventListener("scroll", this.handleScroll)
  },
  mounted() {
    lottie.loadAnimation({
      container: document.getElementById("better"),
      renderer: "svg",
      loop: true,
      autoplay: false,
      animationData: better
    })
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll)
    lottie.destroy()
  },
  data() {
    return {
      currentReport: "credit",
      currentFrame: 0,
      interval: null,
      testimonialInterval: null,
      currentTestimonialIndex: 0,
      testimonials: [
        {
          content:
            "These rental applications have made renting out my townhouse so much easier. It has taken the hassle out of applications for me the landlord and for the tenant. Thank you for making such a great product.",
          name: "Candace Myers",
          userType: "Landlord"
        },
        {
          content:
            "Deals take 2 hours instead of 3 to 4 days. I'm able to get information to clients quicker, they're able to decide quicker, and it gets deals progressing quicker.",
          name: "Ben",
          userType: "Managing Broker"
        },
        {
          content:
            "When we need to screen tenants, we need a service that's reliable, convenient and safe for all parties. Rent Application is all of that.",
          name: "Helen Gray",
          userType: "Landlord"
        }
      ]
    }
  },
  methods: {
    setTestimonialIndex(index) {
      this.currentTestimonialIndex = index
      if (this.testimonialInterval) {
        this.stopCarousel()
      }
    },
    handleScroll() {
      //let elemTop = this.$refs.betterGif.getBoundingClientRect().top
      let elemTop = this.$refs.better.getBoundingClientRect().top
      const isGifVisible = elemTop >= 0 && elemTop <= window.innerHeight

      if (isGifVisible) {
        this.startVideo()
      } else {
        this.resetVideo()
      }

      elemTop = this.$refs.testimonialContainer.getBoundingClientRect().top
      const isTestimonialVisible = elemTop >= 0 && elemTop <= window.innerHeight

      if (isTestimonialVisible) {
        this.startCarousel()
      }
    },
    startCarousel() {
      if (this.testimonialInterval) {
        return
      }

      const that = this
      let interval = setInterval(() => {
        if (that.currentTestimonialIndex === 2) {
          that.currentTestimonialIndex = 0
        } else {
          that.currentTestimonialIndex = that.currentTestimonialIndex + 1
        }
      }, 5000)

      this.testimonialInterval = interval
    },
    stopCarousel() {
      clearInterval(this.testimonialInterval)
    },
    toggleReport(report) {
      this.currentReport = report
    },
    resetVideo() {
      lottie.goToAndStop(0)
      this.currentFrame = 0
      if (this.$refs.firstBar && this.$refs.secondBar) {
        this.$refs.firstBar.style.width = "0%"
        this.$refs.secondBar.style.width = "0%"
      }

      this.interval = null
    },
    restartVideo() {
      this.resetVideo()
      this.startVideo()
    },
    startVideo() {
      lottie.play()
      const that = this
      if (this.interval) {
        return
      }

      let interval = setInterval(() => {
        if (that.currentFrame > 3000) {
          clearInterval(interval)
          that.restartVideo()
        }

        if (that.currentFrame <= 1500 && that.$refs.firstBar) {
          that.$refs.firstBar.style.width = `${
            (that.currentFrame / 1500) * 100.0
          }%`
        }

        if (that.currentFrame > 1500 && that.$refs.secondBar) {
          that.$refs.secondBar.style.width = `${
            ((that.currentFrame - 1500) / 1500) * 100.0
          }%`
        }
        that.currentFrame = that.currentFrame + 1
      }, 10)

      this.interval = interval
    }
  }
}
</script>
<style lang="scss" scoped>
.prospective-background {
  background: url("~@/assets/images/prospective.png") center center no-repeat;
  background-size: cover;
}
.testimonial-background {
  background: url("~@/assets/images/testimonial.png") center center no-repeat;
  background-size: cover;
}

.hero-content {
  background-image: url("~@/assets/images/background.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.slide-enter-active {
  transition: transform 1s ease-in-out;
  transform: translateX(100%);
}

.slide-enter-to {
  transform: translateX(0%);
}

.slide-leave-active {
  transition: transform 0.5s ease-in-out;
  transform: translateX(-100%);
}

.full-width {
  width: 100vw;
  position: relative;
  margin-left: -50vw;
  left: 50%;
}
</style>
